import React, { useState } from "react";
import './modal.css'

export default function Modal(props) {
    const [isOpen, setIsOpen] = useState(props?.isOpen ||false);
    const [adaptive] =useState(props.adaptive)
    const openModal = () => {
        setIsOpen(true);
    }

    const closeModal = () => {
        setIsOpen(false);
    }

    return (
        <>
            {!adaptive ? (
                <div onClick={openModal}>
                    {<props.componentOpen />}
                </div>
            ) : (
                <>
                    <props.componentOpen/>
                    <button onClick={openModal} className="profile_edit-open">Открыть</button>
                </>
            )}

            {isOpen && (
                <div className="modal">
                    <div className="modal-body" style={props.style}>
                        <button className="modal_cancel-button" onClick={closeModal}>&times;</button>
                        <props.component additional={props.additional} close={closeModal} />
                    </div>
                </div>
            )}
        </>
    );
}
